var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.79,
    height: 39.79,
    rx: 19.895,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7945 15.7802C13.7945 14.6437 14.2417 13.5538 15.0376 12.7502C15.8336 11.9466 16.9131 11.4951 18.0388 11.4951C19.1644 11.4951 20.244 11.9466 21.0399 12.7502C21.8359 13.5538 22.2831 14.6437 22.2831 15.7802C22.2831 16.9167 21.8359 18.0066 21.0399 18.8102C20.244 19.6138 19.1644 20.0653 18.0388 20.0653C16.9131 20.0653 15.8336 19.6138 15.0376 18.8102C14.2417 18.0066 13.7945 16.9167 13.7945 15.7802ZM10.6113 27.6412C10.6113 24.3437 13.2574 21.6722 16.5235 21.6722H19.5541C22.8202 21.6722 25.4663 24.3437 25.4663 27.6412C25.4663 28.1902 25.0253 28.6354 24.4815 28.6354H11.5961C11.0523 28.6354 10.6113 28.1902 10.6113 27.6412ZM27.3231 21.94V19.7975H25.201C24.76 19.7975 24.4052 19.4393 24.4052 18.994C24.4052 18.5488 24.76 18.1906 25.201 18.1906H27.3231V16.048C27.3231 15.6028 27.6779 15.2446 28.1189 15.2446C28.5599 15.2446 28.9147 15.6028 28.9147 16.048V18.1906H31.0369C31.4779 18.1906 31.8327 18.5488 31.8327 18.994C31.8327 19.4393 31.4779 19.7975 31.0369 19.7975H28.9147V21.94C28.9147 22.3852 28.5599 22.7434 28.1189 22.7434C27.6779 22.7434 27.3231 22.3852 27.3231 21.94Z",
    fill: "#522474"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddUsers);
export default __webpack_public_path__ + "static/media/icon_add_users.0b6875ac994094356f235d60e9822f84.svg";
export { ForwardRef as ReactComponent };